__turbopack_context__.v({
  "inner": "Collapse-module-scss-module__TCtU9G__inner",
  "inner_hide": "Collapse-module-scss-module__TCtU9G__inner_hide",
  "root": "Collapse-module-scss-module__TCtU9G__root",
});
